
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as passwordL2dpRFAe7_kVhp8zL6h5zgq5WvoRcST6XTocSdklxOUMeta } from "/vercel/path0/app/pages/account/recover/password.vue?macro=true";
import { default as memberiSjnHtsZq_EJOPrDIu8_26XrGoqZFFp9DTAyCCaBzkcMeta } from "/vercel/path0/app/pages/account/member.vue?macro=true";
import { default as ordersz5goJsnbFABGn1LZdP4BAyEswCqldYsYOnm8_UCV7voMeta } from "/vercel/path0/app/pages/account/orders.vue?macro=true";
import { default as profilemclq0JbEWvjxpfUPVJ4r_kH3_leb9erHCoJCap6wDnEMeta } from "/vercel/path0/app/pages/account/profile.vue?macro=true";
import { default as _2ec32d610ZG_gxw7C6Wlq0zsJg_eWi32k45S_ZxpscfIe56DJFUMeta } from "/vercel/path0/app/pages/navigation/2ec32d61.vue?macro=true";
import { default as failedaBGuPL2V6HmycpaG8xFURCOOBxuAqiMkHp4vBGE8B7YMeta } from "/vercel/path0/app/pages/order/failed.vue?macro=true";
import { default as successEoRh8yJPxyx0gBWez27WwWMLrIio7vNSG12_E3J0iE4Meta } from "/vercel/path0/app/pages/order/success.vue?macro=true";
import { default as indexmmKajtpo4vaJxeWcOwjLcEN5PIMaZnDHcphSMy1aJM8Meta } from "/vercel/path0/app/pages/account/index.vue?macro=true";
import { default as cartqhbQzyC_e1f6tlpWpdvtAYnsfnrZ_cmflo_CHqe4_RIMeta } from "/vercel/path0/app/pages/cart.vue?macro=true";
import { default as checkoutwQY7dk0WBdjnwW_tBCIGoAtV6RhZEHVZgb_xWrx1lkMMeta } from "/vercel/path0/app/pages/checkout.vue?macro=true";
import { default as forget_45passwordhauDlUZ_7VmMsJHzdvllIzRc6dmuQ0C0LHhUdf8LsaMMeta } from "/vercel/path0/app/pages/forget-password.vue?macro=true";
import { default as loginBmyj_vfPTDaEDqaiGpr84MHO3dLRczQV7ag0uCpdfccMeta } from "/vercel/path0/app/pages/login.vue?macro=true";
import { default as nl_fIY9_qEKj4emGL6VDMNp1r4iDceSpnW_a7UC0_K1uIMeta } from "/vercel/path0/app/pages/nl.vue?macro=true";
import { default as searchNgih0ybV5qUSeNPcIEX1FEvwyzKOOxMTapSm_DszQLwMeta } from "/vercel/path0/app/pages/search.vue?macro=true";
import { default as sitemapQFJ5YotD5KupsmiG3tWx2k6B7f3Ot635nXp73Ndj1UkMeta } from "/vercel/path0/app/pages/sitemap.vue?macro=true";
import { default as stylingVieweraVc77sUnQ02YxbZvg1TtXE_fFL_szXHRGrbPpfQfQLoMeta } from "/vercel/path0/app/pages/stylingViewer.vue?macro=true";
import { default as _91_46_46_46slug_93AFdIRMaNAoZa3pg52km5tdsRhutxYIyy8lGY_33TL34Meta } from "/vercel/path0/app/pages/[...slug].vue?macro=true";
import { default as component_45stubujmAUFSX4ykkqAJbgWMNq6JoJ582pHF7jznrdwP_NngMeta } from "/vercel/path0/node_modules/.pnpm/nuxt@4.4.2_@babel+core@7.29.0_@babel+plugin-syntax-jsx@7.28.6_@babel+core@7.29.0__@emnapi+cor_su35i2oa2kttk5fpcvuse4akkq/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubujmAUFSX4ykkqAJbgWMNq6JoJ582pHF7jznrdwP_Nng } from "/vercel/path0/node_modules/.pnpm/nuxt@4.4.2_@babel+core@7.29.0_@babel+plugin-syntax-jsx@7.28.6_@babel+core@7.29.0__@emnapi+cor_su35i2oa2kttk5fpcvuse4akkq/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "account-recover-password",
    path: "/account/recover/password",
    component: () => import("/vercel/path0/app/pages/account/recover/password.vue")
  },
  {
    name: "account-member",
    path: "/account/member",
    meta: memberiSjnHtsZq_EJOPrDIu8_26XrGoqZFFp9DTAyCCaBzkcMeta || {},
    component: () => import("/vercel/path0/app/pages/account/member.vue")
  },
  {
    name: "account-orders",
    path: "/account/orders",
    meta: ordersz5goJsnbFABGn1LZdP4BAyEswCqldYsYOnm8_UCV7voMeta || {},
    component: () => import("/vercel/path0/app/pages/account/orders.vue")
  },
  {
    name: "account-profile",
    path: "/account/profile",
    meta: profilemclq0JbEWvjxpfUPVJ4r_kH3_leb9erHCoJCap6wDnEMeta || {},
    component: () => import("/vercel/path0/app/pages/account/profile.vue")
  },
  {
    name: "navigation-2ec32d61",
    path: "/navigation/2ec32d61",
    component: () => import("/vercel/path0/app/pages/navigation/2ec32d61.vue")
  },
  {
    name: "order-failed",
    path: "/order/failed",
    component: () => import("/vercel/path0/app/pages/order/failed.vue")
  },
  {
    name: "order-success",
    path: "/order/success",
    component: () => import("/vercel/path0/app/pages/order/success.vue")
  },
  {
    name: "account",
    path: "/account",
    meta: indexmmKajtpo4vaJxeWcOwjLcEN5PIMaZnDHcphSMy1aJM8Meta || {},
    component: () => import("/vercel/path0/app/pages/account/index.vue")
  },
  {
    name: "cart",
    path: "/cart",
    component: () => import("/vercel/path0/app/pages/cart.vue")
  },
  {
    name: "checkout",
    path: "/checkout",
    component: () => import("/vercel/path0/app/pages/checkout.vue")
  },
  {
    name: "forget-password",
    path: "/forget-password",
    component: () => import("/vercel/path0/app/pages/forget-password.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/vercel/path0/app/pages/login.vue")
  },
  {
    name: "nl",
    path: "/nl",
    component: () => import("/vercel/path0/app/pages/nl.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/vercel/path0/app/pages/search.vue")
  },
  {
    name: "sitemap",
    path: "/nl/sitemap/",
    component: () => import("/vercel/path0/app/pages/sitemap.vue")
  },
  {
    name: "stylingViewer",
    path: "/stylingViewer",
    component: () => import("/vercel/path0/app/pages/stylingViewer.vue")
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93AFdIRMaNAoZa3pg52km5tdsRhutxYIyy8lGY_33TL34Meta || {},
    component: () => import("/vercel/path0/app/pages/[...slug].vue")
  },
  {
    name: component_45stubujmAUFSX4ykkqAJbgWMNq6JoJ582pHF7jznrdwP_NngMeta?.name,
    path: "/sitemap/",
    component: component_45stubujmAUFSX4ykkqAJbgWMNq6JoJ582pHF7jznrdwP_Nng
  },
  {
    name: component_45stubujmAUFSX4ykkqAJbgWMNq6JoJ582pHF7jznrdwP_NngMeta?.name,
    path: "/sitemap/xml",
    component: component_45stubujmAUFSX4ykkqAJbgWMNq6JoJ582pHF7jznrdwP_Nng
  },
  {
    name: component_45stubujmAUFSX4ykkqAJbgWMNq6JoJ582pHF7jznrdwP_NngMeta?.name,
    path: "/",
    component: component_45stubujmAUFSX4ykkqAJbgWMNq6JoJ582pHF7jznrdwP_Nng
  },
  {
    name: component_45stubujmAUFSX4ykkqAJbgWMNq6JoJ582pHF7jznrdwP_NngMeta?.name,
    path: "/order/success&brq_payment_method=afterpay&brq_statuscode=690",
    component: component_45stubujmAUFSX4ykkqAJbgWMNq6JoJ582pHF7jznrdwP_Nng
  },
  {
    name: component_45stubujmAUFSX4ykkqAJbgWMNq6JoJ582pHF7jznrdwP_NngMeta?.name,
    path: "/checkout/finish",
    component: component_45stubujmAUFSX4ykkqAJbgWMNq6JoJ582pHF7jznrdwP_Nng
  }
]